import { Badge } from '../Badge';
import type { DataSummaryProps } from './types';

export const DataSummary = ({ items }: DataSummaryProps) => {
  return (
    <div className="flex flex-wrap gap-2 py-2">
      {items.map((item, i) => (
        <Badge key={i} label={item.label} variant={item.variant} />
      ))}
    </div>
  );
};
